export const EnergyValueViewMode = {
  energyValue: 'energyValue',
  referenceValue: 'referenceValue'
};